import React from 'react';
import Header from "../header/Header";
import BrandGallery from "./BrandGallery";
import BrandSpecialOffer from "./BrandSpecialOffer";
import BrandVideoBox from "./BrandVideoBox";
import Footer from "../footer/Footer";
import NewProducts from "./NewProducts";
import BrandBestSellers from "./BrandBestSellers";
import BrandBanner__1 from "./BrandBanner__1";
import BrandPhoneCable from "./BrandPhoneCable";
import BrandHeadphone from "./BrandHeadphone";
import BrandBanner__2 from "./BrandBanner__2";
import BrandPhoneCharger from "./BrandPhoneCharger";
import BrandPowerBank from "./BrandPowerBank";
import BrandBanner__3 from "./BrandBanner___3";
import BrandCarAccessories from "./BrandCarAccessories";
import BrandInformation from "./BrandInformation";

const BrandPage = () => {
    return (
        <div className="brand-page-wrapper">
            <Header/>
            <div className="brand-page-content">
                <div className="top-banner" style={{backgroundImage: 'url("./assets/sample-image/baseos.png")'}}>
                </div>
                <div className="container">
                    <BrandGallery/>
                    <div className="special-offer-space">
                        <BrandSpecialOffer/>
                    </div>
                </div>
                <BrandVideoBox/>
                <NewProducts/>
                <BrandBestSellers/>
                <BrandBanner__1/>
                <BrandPhoneCable/>
                <BrandHeadphone/>
                <BrandBanner__2/>
                <BrandPhoneCharger/>
                <BrandPowerBank/>
                <BrandBanner__3/>
                <BrandCarAccessories/>
                <BrandBanner__1/>
                <BrandInformation/>
            </div>
            <Footer/>
        </div>
    );
};

export default BrandPage;
